import Vue from 'vue';
import Vuex from 'vuex';
import AppModule from './modules/AppModule';
import BetModule from './modules/BetModule';
import BetFailModule from './modules/BetFailModule';
import BoardModule from './modules/BoardModule';
import BotModule from './modules/BotModule';
import DictionariesModule from './modules/DictionariesModule';
import FeedDballModule from './modules/FeedDballModule';
import FeedLiveModule from './modules/FeedLiveModule';
import FeedLiveBotModule from './modules/FeedLiveBotModule';
import AuthModule from './modules/AuthModule';
import LeagueModule from './modules/LeagueModule';
import LeagueGroupModule from './modules/LeagueGroupModule';
import TeamModule from './modules/TeamModule';
import OrderModule from './modules/OrderModule';
import MenuModule from './modules/MenuModule';
import PageModule from './modules/PageModule';
import UserModule from './modules/UserModule';
import WebSocketModule from './modules/WebSocketModule';
import NotificationModule from './modules/NotificationModule';
import EventModule from './modules/EventModule';
import SearchModule from './modules/SearchModule';

Vue.use(Vuex);
const initialStoreModules = {
    AppModule,
    BetModule,
    BetFailModule,
    BoardModule,
    BotModule,
    DictionariesModule,
    FeedDballModule,
    FeedLiveModule,
    FeedLiveBotModule,
    AuthModule,
    LeagueModule,
    LeagueGroupModule,
    TeamModule,
    MenuModule,
    PageModule,
    OrderModule,
    UserModule,
    WebSocketModule,
    NotificationModule,
    EventModule,
    SearchModule,
};

const store = new Vuex.Store({
    state: {
        uniqAppId: null,
    },
    getters: {
        getUniqAppId: (state) => state.uniqAppId,
    },
    mutations: {
        setUniqAppId(state, uniqAppId) {
            state.uniqAppId = uniqAppId;
        },
        resetState(state) {
            _.forOwn(initialStoreModules, (value, key) => {
                state[key] = _.cloneDeep(value.state);
            });
        },
        resetStateForModule(state, moduleName) {
            if (initialStoreModules[moduleName]) {
                state[moduleName] = _.cloneDeep(initialStoreModules[moduleName].state);
            }
        },
    },
    modules: _.cloneDeep(initialStoreModules),
});

export default store;
